<div mat-tab-nav-bar
mat-align-tabs="center"
class="mat-elevation-z4"
[backgroundColor]="'primary'"
[color]="'white'">

  <a mat-tab-link *ngFor="let page of pages"
  [routerLink]="'/'+page"
  routerLinkActive
  #rla="routerLinkActive"
  (click)="activePage=page"
  [active]="rla.isActive">
    {{page | uppercase}}
  </a>

</div>
